import { ApiBitMask, ApiBitMaskTypes } from '../../../logger/bitMasks/ApiBitMask';
import { DeferredParser } from '../../DeferredParser';
import { Fetcher } from '../../Fetcher';

import { userInfoEndpoint } from './endpoints';
import type { IUserInfoResponse, UserInfoType } from './types';

export interface FetchUserInfoOptions {
  totalBalance: boolean;
}

export interface FetchUserInfoParams {
  JSESSIONID: string;
  force?: boolean;
  baseUrl: string;
}

interface UserInfoPayload {
  parsedResponse: UserInfoType;
  rawResponse: IUserInfoResponse;
}

export class UserInfoFetcherBase extends DeferredParser<FetchUserInfoParams, UserInfoPayload> {
  constructor() {
    super(({ JSESSIONID, force, baseUrl }) =>
      Fetcher.fetch(`${baseUrl}${userInfoEndpoint.url}`, {
        force,
        params: {
          JSESSIONID,
        },
        format: 'json',
      })
    );
  }

  setOptions(options: FetchUserInfoOptions): void {
    this.parseWith((data) => {
      ApiBitMask.apply(ApiBitMaskTypes.Balance);
      const parsedResponse = userInfoEndpoint.parser(data, options);

      return { parsedResponse, rawResponse: data as IUserInfoResponse };
    });
  }
}

export const UserInfoFetcher = new UserInfoFetcherBase();
